exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2zg_nW-vJnugp8wc6jeUQk {\n  height: 20vh;\n}\n\n._3DIID8GA7bOaohgXRrKXh9 {\n  margin-left: 5px;\n}\n\n._2dJZoHkJUU823cT8nmerQ9{\n  margin-bottom: 1vh;\n}\n\n._2XTSILLHYImAoRogATawts {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 30vh;\n}", ""]);

// exports
exports.locals = {
	"actionPanel": "_2zg_nW-vJnugp8wc6jeUQk",
	"formGroup": "_3DIID8GA7bOaohgXRrKXh9",
	"radioField": "_2dJZoHkJUU823cT8nmerQ9",
	"radioText": "_2XTSILLHYImAoRogATawts"
};


//////////////////
// WEBPACK FOOTER
// /builds/alivecorbackend/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/builds/alivecorbackend/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/personalisedPrerequisite/Medanta/components/MedantaAdhocInterpretation.css
// module id = 10609
// module chunks = 25